module.exports = __webpack_public_path__ + "static/media/section3.1.862cae38.jpg";